<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="float-right btn-main"
        color='#006cff'
        outlined
        rounded
        v-bind="attrs"
        v-on="on"
      >
        Add resource
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5"> Add additional documentation</v-card-title>
      <v-card-text>
        <div v-show="!getLoadStatus && getFileUploadStatus !== 200">
          <span class="text-center"
            >Prefix your file with the site ID where you would like the resource
            to be found:</span
          >
          <v-file-input
            v-show="!getLoadStatus && getFileUploadStatus !== 200"
            truncate-length="15"
            @change="extractInfo"
          ></v-file-input>
        </div>
        <div v-show="getLoadStatus && getFileUploadStatus !== 200">
          <span class="text-center">Uploading File</span>
          <v-progress-linear
            color="deep-purple accent-4"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </div>
        <div>
          <v-alert
            v-show="getFileUploadStatus === 200"
            outlined
            type="success"
            text
          >
            Success
          </v-alert>
          <v-alert
            v-show="getFileUploadStatus !== null && getFileUploadStatus !== 200"
            outlined
            type="error"
            text
          >
            Error uploading file
          </v-alert>
        </div></v-card-text
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" text @click="dialog = false"> Cancel </v-btn>
        <v-btn
          v-show="getFileUploadStatus !== 200"
          color="green darken-1"
          text
          :disabled="!file.name"
          @click="addFile"
        >
          Submit
        </v-btn>
        <v-btn
          v-show="getFileUploadStatus === 200"
          color="green darken-1"
          text
          @click="close"
        >
          Complete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      dialog: false,
      file: {},
    };
  },
  computed: {
    ...mapGetters(['getLoadStatus', 'getFileUploadStatus']),
  },
  methods: {
    ...mapActions(['uploadFile']),
    ...mapMutations(['setFileUploadRes']),
    extractInfo(e) {
      this.file = e;
    },
    addFile() {
      const orgGUID = process.env.VUE_APP_ORG_ID;
      this.uploadFile({
        data: this.file,
        fileName: this.file.name,
        key: orgGUID,
        organisationGUID: orgGUID,
      });
    },
    close() {
      this.setFileUploadRes(null);
      this.file = {};
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.action-btn {
  color: #fff;
  margin-left: 10px;
}
</style>
